import { IDetailsListStyles, IStyle } from '@fluentui/react';
import { FontSizes, IH2OTheme } from '@h2oai/ui-kit';

import { IBarChartStyles } from '../../BarChart/BarChart.styles';

export interface IGPTePlotStyles {
  root?: IStyle;
  header?: IStyle;
  dialogContentRoot?: IStyle;
}

export const gptePlotStylesDefault = (): Partial<IGPTePlotStyles> => ({
  root: {
    width: '100%',
    padding: '1rem',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  dialogContentRoot: {},
});

export const gpteBarChartStyles = (theme: IH2OTheme): Partial<IBarChartStyles> => ({
  barChartRoot: { position: 'relative' },
  barChartContainer: { position: 'relative' },
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1,
  },
  overlayText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.gray500,
  },
  overlayErrorText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.red400,
  },
});

export const gptePlotTableStyles = (theme: IH2OTheme): Partial<IDetailsListStyles> => ({
  root: {
    selectors: {
      '.ms-DetailsHeader': {
        padding: '8px 0px',
        paddingRight: 0,
        paddingLeft: 0,
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsHeader-cell': {
        borderRight: '1px solid white',
        color: theme.palette?.gray700,
        backgroundColor: theme.palette?.gray200,
      },
      '.ms-DetailsRow': {
        backgroundColor: theme.palette?.white,
      },
      '.ms-DetailsRow-cell': {
        display: 'flex',
        alignItems: 'center',
        fontSize: FontSizes.xsmall,
        color: theme.palette?.gray600,
        padding: 8,
        backgroundColor: theme.palette?.white,
      },
      '.ms-DetailsRow:hover': {
        backgroundColor: theme.palette?.yellow100,
      },
      '.ms-DetailsList-contentWrapper': {
        overflowY: 'auto',
        backgroundColor: theme.palette?.white,
      },
    },
  },
});
